(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["nosto-placements"] && !Shopify.designMode) return;
  try {
    
  let debounceTimer;

  function afterNostoCardInjected() {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(() => {
      if (window.lazySizes && typeof lazySizes.init === 'function') {
        lazySizes.init();
      }
      if (window.AOS && typeof AOS.refreshHard === 'function') {
        AOS.refreshHard();
      }
      if (window._swat && typeof window._swat.initializeActionButtons === 'function') {
        try { window._swat.initializeActionButtons('.nosto-placements'); } catch (e) {}
      }
      if (typeof window.__initProductGridCarousels === 'function') {
        window.__initProductGridCarousels();
      }
      if (typeof window.__resizeProductGridCarousels === 'function') {
        window.__resizeProductGridCarousels();
        setTimeout(window.__resizeProductGridCarousels, 250);
        setTimeout(window.__resizeProductGridCarousels, 800);
      }
      window.dispatchEvent(new Event('scroll'));
    }, 100);
  }

  document.addEventListener('@nosto/DynamicCard/loaded', afterNostoCardInjected, true);

  function applyTagalysSearchVisibility(root, detail) {
    const d = detail || {};
    if (d.noQuery || d.empty) {
      root.classList.remove('nosto-placements__item--tagalys-hidden');
    } else {
      root.classList.add('nosto-placements__item--tagalys-hidden');
    }
  }

  window.addEventListener('tagalys:search-results', (e) => {
    document.querySelectorAll('[data-nosto-tagalys-search-visibility]').forEach(root => {
      applyTagalysSearchVisibility(root, e.detail);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["seo-banner"] && !Shopify.designMode) return;
  try {
    
  var readMoreContainer = document.querySelector('[data-read-more-container]');
  if (readMoreContainer) {
    var readMoreTruncated = readMoreContainer.querySelector('[data-read-more-truncated]');
    var readMoreFull = readMoreContainer.querySelector('[data-read-more-full]');
    var readMoreButtons = readMoreContainer.querySelectorAll('[data-read-more-toggle]');

    readMoreButtons.forEach(function(btn) {
      btn.addEventListener('click', function() {
        readMoreTruncated.classList.toggle('visually-hidden');
        readMoreFull.classList.toggle('visually-hidden');
      });
    });
  }

  } catch(e) { console.error(e); }
})();
})();
